export default __webpack_public_path__ + "static/media/The Gifts of Imperfection_ Embrace Who You Are ( PDFDrive ).78b4bbee.pdf";